<template>
  <div class="real-time">
    <div class="real-time-input">
      <span class="trend-title">组态地址</span>
      <el-input type="text" placeholder="请录入组态页面地址" v-model="address"></el-input>
    </div>
    <div class="last-save">
      <el-button :loading="urlLoading" size="small" @click="saveUrl" type="primary">保存</el-button>
    </div>
  </div>
</template>

<script>
import apis from '@/apis/device/device'
export default {
  data(){
    return{
      urlLoading:false,//加载状态
      address:'',
      linshiID:'',
    }
  },
  mounted(){
    this.getUrlData()
  },
  methods:{
    //获取数据
    getUrlData(){
      apis.getConfig().then(res=>{
        if(res.code==10000){
          this.address = res.data.list[0].confUrl
          this.linshiID = res.data.list[0].id
        }else{
          this.$message.error(res.message);
          return;
        }
      })
    },
    //保存数据
    saveUrl(){
      this.urlLoading = true;
      let obj = {}
      if(this.linshiID){
        obj.id = this.linshiID
      }
      obj.confUrl = this.address
      apis.saveConfig(obj).then(res=>{
        if(res.code==10000){
          this.urlLoading = false;
          this.$message.success('保存成功');
          this.getUrlData()
        }else{
          this.urlLoading = false;
          this.$message.error(res.message);
          return;
        }
      })
    },
  }
}
</script>
<style lang="less" scoped>
.real-time{ padding-top: 10px;
  .el-input{ width: 50rem;}
}
</style>